// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type { AdvancedPlatformMetricsOperations } from "./advancedPlatformMetrics/index.js";
export type { BlobContainersOperations } from "./blobContainers/index.js";
export type { BlobInventoryPoliciesOperations } from "./blobInventoryPolicies/index.js";
export type { BlobServicesOperations } from "./blobServices/index.js";
export type { ConnectorsOperations } from "./connectors/index.js";
export type { DataSharesOperations } from "./dataShares/index.js";
export type { DeletedAccountsOperations } from "./deletedAccounts/index.js";
export type { EncryptionScopesOperations } from "./encryptionScopes/index.js";
export type { FileServicesOperations } from "./fileServices/index.js";
export type { FileSharesOperations } from "./fileShares/index.js";
export type { LocalUsersOperations } from "./localUsers/index.js";
export type { ManagementPoliciesOperations } from "./managementPolicies/index.js";
export type { NetworkSecurityPerimeterConfigurationsOperations } from "./networkSecurityPerimeterConfigurations/index.js";
export type { ObjectReplicationPoliciesOperations } from "./objectReplicationPolicies/index.js";
export type { OperationsOperations } from "./operations/index.js";
export type { PrivateEndpointConnectionsOperations } from "./privateEndpointConnections/index.js";
export type { PrivateLinkResourcesOperations } from "./privateLinkResources/index.js";
export type { QueueOperations } from "./queue/index.js";
export type { QueueServicesOperations } from "./queueServices/index.js";
export type { SkusOperations } from "./skus/index.js";
export type { StorageAccountsOperations } from "./storageAccounts/index.js";
export type { StorageTaskAssignmentInstancesReportOperations } from "./storageTaskAssignmentInstancesReport/index.js";
export type { StorageTaskAssignmentsOperations } from "./storageTaskAssignments/index.js";
export type { StorageTaskAssignmentsInstancesReportOperations } from "./storageTaskAssignmentsInstancesReport/index.js";
export type { TableOperations } from "./table/index.js";
export type { TableServicesOperations } from "./tableServices/index.js";
export type { UsagesOperations } from "./usages/index.js";
